import React from 'react';
import { getCurrencyMeta } from '../../../utils/currency';

const dateLabel = (value) => {
  const date = value?.toDate ? value.toDate() : value ? new Date(value) : null;
  return date && Number.isFinite(date.getTime()) ? date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : null;
};

export default function BoltOnRenewalSummary({ entry, currency = 'GBP' }) {
  if (!entry) return null;
  const stopped = entry.cancelAtPeriodEnd || entry.manualRenewalsStopped || entry.autoRenew === false || entry.status === 'cancel_at_period_end';
  const transition = entry.renewalTransition;
  const pending = !stopped && ['scheduled', 'bridge_due'].includes(transition?.status);
  const paidThrough = dateLabel(entry.paidThrough || entry.currentPeriodEnd || (pending ? transition.paidThrough : null));
  const nextDate = dateLabel(entry.mode === 'manual' ? entry.nextChargeDate : entry.currentPeriodEnd);
  const { symbol, decimals } = getCurrencyMeta(currency);
  const money = (amount) => `${symbol}${(Number(amount || 0) / (10 ** decimals)).toFixed(decimals)}`;
  const bridgeStart = dateLabel(transition?.bridgeStart);
  const anchor = dateLabel(transition?.alignedRenewalDate);
  return <div className="bolt-on-renewal-summary">
    {paidThrough ? <p>Paid through: <strong>{paidThrough}</strong>.</p> : <p>Paid-through date not yet available.</p>}
    {pending ? <>
      <p>Your current paid period stays unchanged. {entry.mode === 'subscription' ? 'An automatic pro-rata payment' : 'A pro-rata payment'} {transition.status === 'bridge_due' ? 'is due' : 'will be due'} on <strong>{bridgeStart}</strong> to cover {bridgeStart} to {anchor}.
        {transition.bridgeChargeAmount != null && <> {entry.mode === 'subscription' ? 'Scheduled amount' : 'Amount before any checkout fees'}: <strong>{money(entry.mode === 'manual' ? transition.bridgeBaseAmount : transition.bridgeChargeAmount)}</strong>.</>}
      </p>
      <p>Annual renewals then start on <strong>{anchor}</strong>{transition.fullChargeAmount != null && <> at {money(transition.fullChargeAmount)} per year</>}. No immediate charge or credit is made for this change.</p>
    </> : !stopped && nextDate && <p>Next {entry.mode === 'subscription' ? 'automatic payment' : 'renewal payment'}: <strong>{nextDate}</strong>.</p>}
  </div>;
}
